var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M21.2695 9.18029C20.9795 8.72029 20.6695 8.29029 20.3495 7.89029C19.9795 7.42029 19.2795 7.38029 18.8595 7.80029L15.8595 10.8003C16.0795 11.4603 16.1195 12.2203 15.9195 13.0103C15.5695 14.4203 14.4295 15.5603 13.0195 15.9103C12.2295 16.1103 11.4695 16.0703 10.8095 15.8503C10.8095 15.8503 9.37946 17.2803 8.34946 18.3103C7.84946 18.8103 8.00946 19.6903 8.67946 19.9503C9.74946 20.3603 10.8595 20.5703 11.9995 20.5703C13.7795 20.5703 15.5095 20.0503 17.0895 19.0803C18.6995 18.0803 20.1495 16.6103 21.3195 14.7403C22.2695 13.2303 22.2195 10.6903 21.2695 9.18029Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M14.0206 9.97965L9.98062 14.0196C9.47062 13.4996 9.14062 12.7796 9.14062 11.9996C9.14062 10.4296 10.4206 9.13965 12.0006 9.13965C12.7806 9.13965 13.5006 9.46965 14.0206 9.97965Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M18.25 5.74969L14.86 9.13969C14.13 8.39969 13.12 7.95969 12 7.95969C9.76 7.95969 7.96 9.76969 7.96 11.9997C7.96 13.1197 8.41 14.1297 9.14 14.8597L5.76 18.2497H5.75C4.64 17.3497 3.62 16.1997 2.75 14.8397C1.75 13.2697 1.75 10.7197 2.75 9.14969C3.91 7.32969 5.33 5.89969 6.91 4.91969C8.49 3.95969 10.22 3.42969 12 3.42969C14.23 3.42969 16.39 4.24969 18.25 5.74969Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M14.8601 12.0001C14.8601 13.5701 13.5801 14.8601 12.0001 14.8601C11.9401 14.8601 11.8901 14.8601 11.8301 14.8401L14.8401 11.8301C14.8601 11.8901 14.8601 11.9401 14.8601 12.0001Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M21.7709 2.22988C21.4709 1.92988 20.9809 1.92988 20.6809 2.22988L2.23086 20.6899C1.93086 20.9899 1.93086 21.4799 2.23086 21.7799C2.38086 21.9199 2.57086 21.9999 2.77086 21.9999C2.97086 21.9999 3.16086 21.9199 3.31086 21.7699L21.7709 3.30988C22.0809 3.00988 22.0809 2.52988 21.7709 2.22988Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }